export default {
	ENDPOINT: "https://api.asia.covergo.com/graphql",
	ENDPOINT_V2: "https://api-v2.covergo.com/graphql",
	CLIENT_ID: "covergo_crm"
}
